import { useAppSelector } from 'store/hook';
import { stringToHexColor } from 'utils/glencore';
import { isDarkTheme } from 'utils/theme';

interface ColorCodingsProps {
  timelineView: 'location' | 'asset';
}
const ColorCodings = ({ timelineView }: ColorCodingsProps) => {
  const { theme } = useAppSelector((state) => state.authReducer.customer);
  const isDark = isDarkTheme(theme);

  const locationTimelineColors = [
    {
      name: 'Unproductive Asset',
      color: '#a30000ff',
      shape: 'cylinder',
    },
    {
      name: 'Mucking',
      color: '#10B981',
      shape: 'cylinder',
    },
    {
      name: 'Drill',
      color: '#c19a6b80',
      shape: 'cylinder',
    },
    {
      name: 'Bolt',
      color: '#8191d3',
      shape: 'cylinder',
    },
    {
      name: 'Day Shift',
      color: `${stringToHexColor(`Day Shift_${isDark ? 'dark' : 'light'}`)}80`,
      shape: 'square',
    },
    {
      name: 'Night Shift',
      color: `${stringToHexColor(
        `Night Shift_${isDark ? 'dark' : 'light'}`
      )}30`,
      shape: 'square',
    },
  ];

  const assetTimelineColors = [
    {
      name: 'Day Shift',
      color: `${stringToHexColor(`Day Shift_${isDark ? 'dark' : 'light'}`)}80`,
      shape: 'square',
    },
    {
      name: 'Night Shift',
      color: `${stringToHexColor(
        `Night Shift_${isDark ? 'dark' : 'light'}`
      )}30`,
      shape: 'square',
    },
  ];

  return (
    <div className="flex items-center justify-start gap-2">
      {(timelineView === 'location'
        ? locationTimelineColors
        : assetTimelineColors
      ).map((color) => (
        <div key={color.name} className="flex items-center gap-2">
          <span
            style={{
              width: '24px',
              height: color.shape === 'cylinder' ? '8px' : '24px',
              backgroundColor: color.color,
              borderRadius: '4px',
              display: 'inline-block',
              border: '1px solid',
            }}
          />
          <span className="text-xs" style={{ color: isDark ? '#fff' : '#000' }}>
            {color.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ColorCodings;
